// Servicio para manejar datos de colegios, áreas y materias en localStorage
// y el colegio activo seleccionado por el usuario.

const COLEGIO_KEY = 'app_colegios';
const AREAS_KEY = 'app_areas';
const MATERIAS_KEY = 'app_materias';
const ACTIVE_COLEGIO_KEY = 'app_colegio_activa';
const ACTIVE_COLEGIO_ID_KEY = 'app_colegio_activa_id';
const FEATURE_FLAGS_KEY = 'app_feature_flags';

const safeSetItem = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.error('❌ Error guardando en localStorage:', key, error);
  }
};

const safeGetItem = (key, fallback) => {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : fallback;
  } catch (error) {
    console.error('❌ Error leyendo desde localStorage:', key, error);
    return fallback;
  }
};

const ColegioService = {
  setColegioData({ colegios = [], areas = [], materias = [] }) {
    safeSetItem(COLEGIO_KEY, colegios);
    safeSetItem(AREAS_KEY, areas);
    safeSetItem(MATERIAS_KEY, materias);
  },

  getColegios() {
    return safeGetItem(COLEGIO_KEY, []);
  },

  getAreas() {
    return safeGetItem(AREAS_KEY, []);
  },

  getMaterias() {
    return safeGetItem(MATERIAS_KEY, []);
  },

  setActiveColegio(colegio) {
    safeSetItem(ACTIVE_COLEGIO_KEY, colegio || null);
    const regId = colegio?.id || colegio?.Id || null;
    safeSetItem(ACTIVE_COLEGIO_ID_KEY, regId);
  },

  getActiveColegio() {
    return safeGetItem(ACTIVE_COLEGIO_KEY, null);
  },

  getActiveColegioId() {
    return safeGetItem(ACTIVE_COLEGIO_ID_KEY, null);
  },

  setFeatureFlags(flags) {
    safeSetItem(FEATURE_FLAGS_KEY, Array.isArray(flags) ? flags : []);
  },

  getFeatureFlags() {
    return safeGetItem(FEATURE_FLAGS_KEY, []);
  },

  clearColegioData() {
    try {
      localStorage.removeItem(COLEGIO_KEY);
      localStorage.removeItem(AREAS_KEY);
      localStorage.removeItem(MATERIAS_KEY);
      localStorage.removeItem(ACTIVE_COLEGIO_KEY);
      localStorage.removeItem(ACTIVE_COLEGIO_ID_KEY);
      localStorage.removeItem(FEATURE_FLAGS_KEY);
    } catch (error) {
      console.error('❌ Error limpiando datos de colegios en localStorage:', error);
    }
  }
};

export default ColegioService;
